import { Col, Row, Section } from 'components/grid'
import OverlayVideo from 'components/overlay-video'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function Videos({ ...props }) {
	const { language, standard } = useContext(CoreAdoptionContext)

	return (
		<Section margin="mt-8" id={formatSectionId(props)} className="scroll-mt-14">
			<Row>
				<Col>
					{language === 'english' && standard === 'ccss' && <OverlayVideo title="ARC Core Overview" />}
					{language === 'spanish' && standard === 'ccss' && <OverlayVideo title="ARC Core en español Overview" />}
					{language === 'english' && standard === 'teks' && <OverlayVideo title="ARC Core Overview (TEKS)" />}
					{language === 'spanish' && standard === 'teks' && <OverlayVideo title="ARC Core en español Overview" />}
				</Col>
			</Row>
		</Section>
	)
}
